export default function textBrief(text, max = 45, ellipsis = "...") {
  if (text == null) return "";
  const clean = String(text).replace(/\s+/g, " ").trim();

  if (clean.length <= max) return clean;

  if (max <= ellipsis.length) return ellipsis.slice(0, max);

  const cut = clean.lastIndexOf(" ", max);
  const head = cut > 0 ? clean.slice(0, cut) : clean.slice(0, max);

  return head.trimEnd() + ellipsis;
}